/**
 * Inayah Size Guide modal — open/close/scroll-lock (Release theme).
 *
 * Open:  click any [data-inayah-size-guide-open]
 * Close: click [data-inayah-size-guide-close] (X / backdrop), press Escape,
 *        or dispatch the 'inayah:size-guide:close' event (fired after add-to-cart).
 *
 * The modal is re-parented to <body> on first open so its position:fixed is
 * viewport-relative and cannot be clipped by an ancestor with transform/filter.
 */
(function () {
  'use strict';

  var MODAL_ID = 'inayah-size-guide-modal';
  var movedToBody = false;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  var lastFocused = null;

  function focusables(m) {
    return Array.prototype.filter.call(
      m.querySelectorAll('button, [href], input, select, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open() {
    var m = getModal();
    if (!m) return;

    if (!movedToBody && m.parentNode !== document.body) {
      document.body.appendChild(m);
      movedToBody = true;
    }

    lastFocused = document.activeElement;
    m.hidden = false;
    void m.offsetWidth; // reflow so the transition runs
    m.classList.add('is-open');
    document.body.classList.add('inayah-sg-lock');

    var scroller = m.querySelector('.inayah-sg__scroll');
    if (scroller) scroller.scrollTop = 0;

    // Move focus into the modal so keyboard/screen-reader users land inside it.
    var closeBtn = m.querySelector('.inayah-sg-close');
    (closeBtn || m).focus();
  }

  function close() {
    var m = getModal();
    if (!m || m.hidden) return;

    m.classList.remove('is-open');
    document.body.classList.remove('inayah-sg-lock');

    var done = function () {
      if (!m.classList.contains('is-open')) m.hidden = true;
      m.removeEventListener('transitionend', done);
    };
    m.addEventListener('transitionend', done);
    setTimeout(done, 300); // fallback if transitionend doesn't fire

    // Return focus to whatever opened the modal.
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-inayah-size-guide-open]');
    if (opener) {
      e.preventDefault();
      open();
      return;
    }
    var closer = e.target.closest('[data-inayah-size-guide-close]');
    if (closer && closer.closest('#' + MODAL_ID)) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    var m = getModal();
    if (!m || !m.classList.contains('is-open')) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      close();
      return;
    }

    // Trap Tab focus inside the modal.
    if (e.key === 'Tab') {
      var els = focusables(m);
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!m.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('inayah:size-guide:close', close);
})();
